/*
 * Sepet çekmecesindeki "ŞİMDİ 4 AL 3 ÖDE !" önerileri: listeyi doldurma
 * (dosyanın sonunda) ve "Ekle" düğmesi.
 *
 * Ürün sayfasındaki sepete ekle formu (product-form.js) ile aynı yolu izler:
 * önce temaya "sepete ekleniyor" olayını duyurur, sonra Shopify'a ekler ve
 * gelen yeni sepet HTML'ini olayla birlikte teslim eder. Böylece sepet
 * çekmecesi ve üstteki sepet sayısı kendiliğinden yenilenir.
 */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

const SEPET_BOLUMU = 'cart-drawer-section';

document.addEventListener('click', async (event) => {
  const dugme = event.target instanceof Element ? event.target.closest('.cart-upsell__ekle') : null;
  if (!(dugme instanceof HTMLButtonElement) || dugme.disabled) return;

  const satir = dugme.closest('.cart-upsell__ekle-satir');
  const secim = satir?.querySelector('.cart-upsell__secim');
  const varyant = secim instanceof HTMLSelectElement || secim instanceof HTMLInputElement ? secim.value : '';
  if (!varyant) return;

  dugme.disabled = true;
  dugme.classList.add('is-loading');

  const bekleyen = CartLinesUpdateEvent.createPromise();
  dugme.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: varyant, quantity: 1 }],
      promise: bekleyen.promise,
    })
  );

  try {
    const cevap = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(varyant), quantity: 1 }], sections: SEPET_BOLUMU }),
    }).then((r) => r.json());

    const sepet = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());

    if (cevap.status) {
      dugme.dispatchEvent(new CartErrorEvent({ error: cevap.description || cevap.message, code: 'INVALID' }));
    }

    bekleyen.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(sepet),
      detail: {
        items: sepet.items,
        source: 'sepet-oneri',
        itemCount: 1,
        sections: cevap.sections,
        didError: Boolean(cevap.status),
      },
    });
  } catch (hata) {
    console.error(hata);
    bekleyen.reject(hata);
  } finally {
    dugme.disabled = false;
    dugme.classList.remove('is-loading');
  }
});

/*
 * Öneri listesini doldurma: kaynaktaki (tüm ürünler ya da seçili koleksiyon)
 * bütün ürünler bir kez çekilir, ziyarete özel bir tohumla karıştırılır ve
 * sepette olmayan, stokta olan ilk N ürün kart olarak basılır.
 * Tohum sessionStorage'da: aynı ziyarette sıra sabit, yeni ziyarette farklı.
 */
const HARIC = new Set(['ozel-hediye-kutusu']);
const kokYol = window.Shopify?.routes?.root || '/';
/** @type {Map<string, Promise<any[]>>} */
const havuzlar = new Map();

function oturumAl(anahtar) {
  try { return sessionStorage.getItem(anahtar); } catch (e) { return null; }
}
function oturumYaz(anahtar, deger) {
  try { sessionStorage.setItem(anahtar, deger); } catch (e) {}
}

function tohumAl() {
  let tohum = Number(oturumAl('sepet_oneri_tohum'));
  if (!tohum) {
    tohum = Math.floor(Math.random() * 2 ** 31) + 1;
    oturumYaz('sepet_oneri_tohum', String(tohum));
  }
  return tohum;
}

/** Tohumlu karıştırma (aynı tohum = aynı sıra) */
function karistir(dizi, tohum) {
  let t = tohum;
  const rastgele = () => {
    t = (t + 0x6d2b79f5) | 0;
    let x = Math.imul(t ^ (t >>> 15), 1 | t);
    x = (x + Math.imul(x ^ (x >>> 7), 61 | x)) ^ x;
    return ((x ^ (x >>> 14)) >>> 0) / 4294967296;
  };
  const kopya = dizi.slice();
  for (let i = kopya.length - 1; i > 0; i--) {
    const j = Math.floor(rastgele() * (i + 1));
    [kopya[i], kopya[j]] = [kopya[j], kopya[i]];
  }
  return kopya;
}

async function sayfalariCek(yol) {
  const urunler = [];
  for (let sayfa = 1; sayfa <= 10; sayfa++) {
    const cevap = await fetch(`${yol}/products.json?limit=250&page=${sayfa}`);
    if (!cevap.ok) break;
    const { products } = await cevap.json();
    urunler.push(...products);
    if (products.length < 250) break;
  }
  return urunler;
}

/** Kaynağın ürünlerini getirir; ziyaret boyunca saklar */
function havuzAl(kaynak) {
  const anahtar = `sepet_oneri_${kaynak}_${kokYol}`;
  if (havuzlar.has(anahtar)) return havuzlar.get(anahtar);

  const is = (async () => {
    const kayitli = oturumAl(anahtar);
    if (kayitli) {
      try { return JSON.parse(kayitli); } catch (e) {}
    }
    // Ürün adları her dilde aynı kalsın diye adlar Türkçe kökten; seçenek adları ziyaretçinin dilinden
    const asil = await sayfalariCek(`/collections/${kaynak}`);
    const yerel = kokYol === '/' ? asil : await sayfalariCek(`${kokYol}collections/${kaynak}`);
    const yerelVaryant = new Map();
    for (const urun of yerel) for (const v of urun.variants) yerelVaryant.set(v.id, v.title);

    const sade = asil.map((urun) => {
      const varyantlar = urun.variants
        .filter((v) => v.available)
        .map((v) => ({ id: v.id, ad: yerelVaryant.get(v.id) || v.title, fiyat: v.price, eski: v.compare_at_price }));
      return {
        id: urun.id,
        tutamac: urun.handle,
        ad: urun.title,
        gorsel: urun.images?.[0]?.src || '',
        varyantlar,
        tek: urun.variants.length === 1 && urun.variants[0].title === 'Default Title',
      };
    }).filter((u) => u.varyantlar.length > 0 && !HARIC.has(u.tutamac));

    oturumYaz(anahtar, JSON.stringify(sade));
    return sade;
  })();
  havuzlar.set(anahtar, is);
  return is;
}

function paraYaz(tutar, bicim) {
  const sayi = Math.round(parseFloat(tutar) * 100) / 100;
  const ayir = (n, binlik, ondalik, hane) => {
    const [tam, kesir] = n.toFixed(hane).split('.');
    return tam.replace(/\B(?=(\d{3})+(?!\d))/g, binlik) + (kesir ? ondalik + kesir : '');
  };
  return (bicim || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, tur) => {
    switch (tur) {
      case 'amount_no_decimals': return ayir(sayi, ',', '.', 0);
      case 'amount_with_comma_separator': return ayir(sayi, '.', ',', 2);
      case 'amount_no_decimals_with_comma_separator': return ayir(sayi, '.', ',', 0);
      default: return ayir(sayi, ',', '.', 2);
    }
  });
}

const kac = (metin) =>
  String(metin).replace(/[&<>"']/g, (h) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[h]);

function kartYaz(urun, bilgi) {
  const v = urun.varyantlar[0];
  const url = `${kokYol}products/${urun.tutamac}`;
  const gorsel = urun.gorsel ? `${urun.gorsel}${urun.gorsel.includes('?') ? '&' : '?'}width=200` : '';
  const indirimli = v.eski && parseFloat(v.eski) > parseFloat(v.fiyat);
  const secim = urun.tek
    ? `<input type="hidden" class="cart-upsell__secim" value="${v.id}">`
    : `<select class="cart-upsell__secim" aria-label="${kac(urun.ad)}">${urun.varyantlar
        .map((x) => `<option value="${x.id}">${kac(x.ad)}</option>`)
        .join('')}</select>`;
  const ekle = bilgi.dataset.hizli === 'false'
    ? ''
    : `<div class="cart-upsell__ekle-satir">${secim}<button type="button" class="cart-upsell__ekle">${kac(bilgi.dataset.ekle || 'Ekle')}</button></div>`;

  return `<li class="cart-upsell__item">
    <a class="cart-upsell__media" href="${url}" aria-label="${kac(urun.ad)}">${gorsel ? `<img src="${gorsel}" alt="" loading="lazy">` : ''}</a>
    <div class="cart-upsell__info">
      <a class="cart-upsell__title" href="${url}">${kac(urun.ad)}</a>
      <div class="cart-upsell__price">${indirimli ? `<s>${paraYaz(v.eski, bilgi.dataset.para)}</s>` : ''}<span${indirimli ? ' class="cart-upsell__price--sale"' : ''}>${paraYaz(v.fiyat, bilgi.dataset.para)}</span></div>
      ${ekle}
    </div>
  </li>`;
}

async function doldur(kutu) {
  const bilgi = kutu.querySelector('.cart-upsell__bilgi');
  const liste = kutu.querySelector('.cart-upsell__list');
  if (!(bilgi instanceof HTMLElement) || !liste) return;

  const imza = [bilgi.dataset.kaynak, bilgi.dataset.adet, bilgi.dataset.sepettekiler].join('|');
  if (kutu.dataset.imza === imza) return;
  kutu.dataset.imza = imza;

  try {
    const havuz = await havuzAl(bilgi.dataset.kaynak || 'all');
    if (kutu.dataset.imza !== imza) return; // bu arada sepet değişti
    const sepette = new Set((bilgi.dataset.sepettekiler || '').split(',').filter(Boolean).map(Number));
    const adet = Number(bilgi.dataset.adet) || 12;
    const secilen = karistir(havuz, tohumAl()).filter((u) => !sepette.has(u.id)).slice(0, adet);

    liste.innerHTML = secilen.map((u) => kartYaz(u, bilgi)).join('');
    kutu.hidden = secilen.length === 0;
  } catch (hata) {
    console.error(hata);
    kutu.hidden = true;
  }
}

function hepsiniDoldur() {
  document.querySelectorAll('[data-sepet-oneri]').forEach((kutu) => doldur(kutu));
}

let bekliyor = false;
new MutationObserver(() => {
  if (bekliyor) return;
  bekliyor = true;
  requestAnimationFrame(() => {
    bekliyor = false;
    hepsiniDoldur();
  });
}).observe(document.documentElement, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['data-sepettekiler', 'data-kaynak', 'data-adet'],
});
hepsiniDoldur();
